<div class="floating-card"
     [style.transform]="'translate(' + position.x + 'px, ' + position.y + 'px)'"
     [style.width.px]="cardWidth" [style.height.px]="cardHeight"
     [style.top.px]="0" [style.left.px]="0" [class.dragging]="isDragging"
     [class.snapped]="isSnapped" [class.resizing]="isResizing"
     [class.view-mode]="!draggable && !resizable"
     [attr.data-resize-direction]="activeResizeDirection"
     (mousedown)="onMouseDown($event)" (click)="onCardClick($event)"
     (keyup.enter)="onCardClick($event)" (keyup.space)="onCardClick($event)"
     tabindex="0">

     <!-- Card content  -->
     <via-widget-content
          [widget]="widgetConfig"
          [showCloseButton]="canCloseWidget"
          [isLiveData]="isLiveData"
          (closeClicked)="onCloseClick()">
     </via-widget-content>

     <!-- Resize handles -->
     @if (resizable) {
     <div class="resize-handle resize-handle-right"
          (mousedown)="onResizeStart($event, 'right')" title="Resize right"
          tabindex="0"></div>
     <div class="resize-handle resize-handle-bottom"
          (mousedown)="onResizeStart($event, 'bottom')" title="Resize bottom"
          tabindex="0"></div>
     <div class="resize-handle resize-handle-left"
          (mousedown)="onResizeStart($event, 'left')" title="Resize left"
          tabindex="0"></div>
     <div class="resize-handle resize-handle-top"
          (mousedown)="onResizeStart($event, 'top')" title="Resize top"
          tabindex="0"></div>
     <div class="resize-handle resize-handle-bottom-right"
          (mousedown)="onResizeStart($event, 'bottom-right')"
          title="Resize bottom-right" tabindex="0"></div>
     <div class="resize-handle resize-handle-bottom-left"
          (mousedown)="onResizeStart($event, 'bottom-left')"
          title="Resize bottom-left" tabindex="0"></div>
     <div class="resize-handle resize-handle-top-right"
          (mousedown)="onResizeStart($event, 'top-right')"
          title="Resize top-right" tabindex="0"></div>
     <div class="resize-handle resize-handle-top-left"
          (mousedown)="onResizeStart($event, 'top-left')"
          title="Resize top-left" tabindex="0"></div>
     }

</div>
